import { fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import type { BaseQueryFn, FetchArgs, FetchBaseQueryError } from '@reduxjs/toolkit/query';
import { logout } from 'src/services/auth/authSlice';
import { API_URL } from 'src/utils/config';

const baseQuery = fetchBaseQuery({
    baseUrl: API_URL,
    prepareHeaders: (headers) => {
        const token = window.localStorage.getItem('token');
        if (token) {
            headers.set('Authorization', `Bearer ${token}`);
        }
        return headers;
    },
});

export const baseQueryWithInterceptor: BaseQueryFn<
    string | FetchArgs,
    unknown,
    FetchBaseQueryError
> = async (args, api, extraOptions) => {
    const result = await baseQuery(args, api, extraOptions);

    // Skip 401 redirect for auth endpoints — they handle errors themselves
    const requestUrl = typeof args === 'string' ? args : args.url;
    const isAuthEndpoint = requestUrl?.includes('user/login') || requestUrl?.includes('user/verify');

    if (!isAuthEndpoint && result.error && (result.error.status === 401 || (result.error.status === 'PARSING_ERROR' && (result.error as any).originalStatus === 401))) {
        // Clear the token in Redux state
        api.dispatch(logout());

        // Clear local cache completely
        window.localStorage.clear();
        window.sessionStorage.clear();

        // Redirect to login page and forcefully reload the environment
        window.location.assign('/login');
    }

    return result;
};
